import React from 'react';
import { MapPin, Facebook, Instagram, Linkedin, Twitter, ArrowUp } from 'lucide-react';
import { contactInfo, navLinks } from '../data/mock';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-gradient-to-b from-[#0b2f5c] to-[#08234a] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <div className="relative w-10 h-10 rounded-full bg-gradient-to-br from-sky-300 to-sky-500 flex items-center justify-center shadow-lg">
                <MapPin className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <span className="text-2xl font-bold tracking-tight">
                Ma<span className="text-sky-300">Life</span>
              </span>
            </div>
            <p className="text-white/70 leading-relaxed mb-6 max-w-md">
              Connecting Botswana to essential services — fast, safe, and reliable. Built by Batswana, for Batswana.
            </p>
            <div className="flex items-center gap-3">
              {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-sky-400 flex items-center justify-center transition-colors"
                  aria-label={`Social link ${i}`}
                >
                  <Icon className="w-4 h-4" strokeWidth={2} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-sky-300 mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-white/70 hover:text-sky-300 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-sky-300 mb-4">Get in touch</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li>{contactInfo.office}</li>
              <li>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-sky-300 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li>
                <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="hover:text-sky-300 transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {year} MaLife (Matshelonyana). All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-sky-300 transition-colors">Privacy Policy</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-sky-300 transition-colors">Terms of Service</a>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-flex items-center gap-1 hover:text-sky-300 transition-colors"
            >
              Back to top <ArrowUp className="w-3 h-3" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
